import { ArchiveArrowUpOutlineIcon } from './ArchiveArrowUpOutlineIcon';

/**
 * author: frankgrinaert
 * id 643EF8E3-148D-4858-85C6-A965822B74CF
 * name archive-arrow-up-outline
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-arrow-up-outline.svg
 * tags
 */
export const BoxArrowUpOutlineIcon = ArchiveArrowUpOutlineIcon;
export default BoxArrowUpOutlineIcon